import { Component, ChangeDetectionStrategy } from '@angular/core';

/** Avion en papier : « Envoyer ». Hérite de la couleur du texte et remplit son hôte. */
@Component({
  selector: 'vw-send-icon',
  imports: [],
  host: { class: 'inline-block h-6 w-6' },
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
})
export class SendIconComponent {}
